import { playerNetOnHole } from '@/lib/games/engine/helpers';
import type { CourseHole } from '@/lib/db/types';
import type { RoundPlayer } from '@/lib/games/engine/types';

export function sixesPairings(holeIx: number): [number[], number[]] {
  if (holeIx < 6) return [[0, 1], [2, 3]];
  if (holeIx < 12) return [[0, 2], [1, 3]];
  return [[0, 3], [1, 2]];
}

export function computeSixesTotals(
  players: RoundPlayer[],
  scores: Record<string, (number | null)[]>,
  holes: CourseHole[],
  playerOrder: string[],
): Record<string, number> {
  const totals: Record<string, number> = {};
  playerOrder.forEach((k) => { totals[k] = 0; });
  const keys = playerOrder.slice(0, 4);
  if (keys.length < 4) return totals;

  holes.forEach((h, hi) => {
    const [teamA, teamB] = sixesPairings(hi);
    const netA = Math.min(
      ...teamA.map((ix) => {
        const p = players.find((x) => x.playerKey === keys[ix]);
        if (!p) return 99;
        return playerNetOnHole(p, hi, holes, scores[keys[ix]] || [], 'bestball', players) ?? 99;
      }),
    );
    const netB = Math.min(
      ...teamB.map((ix) => {
        const p = players.find((x) => x.playerKey === keys[ix]);
        if (!p) return 99;
        return playerNetOnHole(p, hi, holes, scores[keys[ix]] || [], 'bestball', players) ?? 99;
      }),
    );
    if (netA === 99 || netB === 99) return;
    if (netA < netB) {
      teamA.forEach((ix) => { totals[keys[ix]] = (totals[keys[ix]] || 0) + 1; });
    } else if (netB < netA) {
      teamB.forEach((ix) => { totals[keys[ix]] = (totals[keys[ix]] || 0) + 1; });
    }
  });
  return totals;
}
